var map = {
	"./Accessory.svg": 6000,
	"./Armor.svg": 771,
	"./Arrow.svg": 5837,
	"./Augment.svg": 6955,
	"./Balanced.svg": 2402,
	"./Boot.svg": 7026,
	"./Camp.svg": 4401,
	"./Charm.svg": 2699,
	"./Cloak.svg": 3686,
	"./Clothing.svg": 2994,
	"./Damage.svg": 7821,
	"./Danger.svg": 1259,
	"./Defend.svg": 3898,
	"./Defensive.svg": 1713,
	"./Essence.svg": 9568,
	"./Food.svg": 2958,
	"./General.svg": 614,
	"./Grenade.svg": 2024,
	"./Health.svg": 7128,
	"./Helmet.svg": 3725,
	"./Herb.svg": 7067,
	"./Layered Armor.svg": 2811,
	"./Luxury.svg": 3221,
	"./Medicine.svg": 1630,
	"./Momentum.svg": 316,
	"./Move.svg": 3789,
	"./Natural.svg": 9493,
	"./Neutral.svg": 5575,
	"./Offensive.svg": 3263,
	"./Outer Armor.svg": 9086,
	"./Patient.svg": 6841,
	"./Poison.svg": 4966,
	"./Potion.svg": 2175,
	"./Recovery.svg": 1335,
	"./Skill.svg": 7585,
	"./Strike.svg": 9512,
	"./Stun.svg": 7622,
	"./Supply.svg": 9187,
	"./Support.svg": 2875,
	"./Tool.svg": 812,
	"./Trinket.svg": 1063,
	"./Vitality.svg": 8720,
	"./disciplines/Anvil.svg": 7544,
	"./disciplines/Archetype.svg": 5811,
	"./disciplines/Artillery.svg": 6816,
	"./disciplines/Blaze.svg": 8422,
	"./disciplines/Bloom.svg": 235,
	"./disciplines/Camp.svg": 9965,
	"./disciplines/Controller.svg": 3954,
	"./disciplines/Courier.svg": 4263,
	"./disciplines/Crafting.svg": 5984,
	"./disciplines/Defender.svg": 7471,
	"./disciplines/Detonation.svg": 2865,
	"./disciplines/Downtime.svg": 661,
	"./disciplines/Earth.svg": 846,
	"./disciplines/Flame.svg": 4931,
	"./disciplines/Gale.svg": 6875,
	"./disciplines/Grounding.svg": 5349,
	"./disciplines/Inventory.svg": 1950,
	"./disciplines/Land.svg": 7381,
	"./disciplines/Metal.svg": 7983,
	"./disciplines/Mountain.svg": 183,
	"./disciplines/Shaper.svg": 5777,
	"./disciplines/Skill.svg": 285,
	"./disciplines/Stoneheart.svg": 1923,
	"./disciplines/Storm.svg": 1821,
	"./disciplines/Striker.svg": 5142,
	"./disciplines/Supporter.svg": 178,
	"./disciplines/Survivor.svg": 9928,
	"./disciplines/Tide.svg": 1462,
	"./disciplines/Travel.svg": 3446,
	"./disciplines/Tremorsight.svg": 3396,
	"./disciplines/Tundra.svg": 8178,
	"./disciplines/Water.svg": 4091,
	"./disciplines/Wind.svg": 7980,
	"./disciplines/Wood.svg": 2573,
	"./statuses/Accelerated.svg": 3420,
	"./statuses/Agile.svg": 393,
	"./statuses/Airborne.svg": 3909,
	"./statuses/Alight.svg": 6576,
	"./statuses/Anguished.svg": 5785,
	"./statuses/Bleeding.svg": 1911,
	"./statuses/Blinded.svg": 2335,
	"./statuses/Break.svg": 4312,
	"./statuses/Burned.svg": 7699,
	"./statuses/Calm.svg": 146,
	"./statuses/Charging.svg": 1470,
	"./statuses/Concentrating.svg": 3784,
	"./statuses/Courageous.svg": 9332,
	"./statuses/Dazed.svg": 3503,
	"./statuses/Disarm.svg": 7909,
	"./statuses/Engaged.svg": 2666,
	"./statuses/Enraged.svg": 1055,
	"./statuses/Entangled.svg": 2789,
	"./statuses/Exposed.svg": 8369,
	"./statuses/Fatigue.svg": 2298,
	"./statuses/Flying.svg": 2682,
	"./statuses/Frightened.svg": 9061,
	"./statuses/Frozen.svg": 2225,
	"./statuses/Grabbed.svg": 7330,
	"./statuses/Guarding.svg": 4126,
	"./statuses/Hobbled.svg": 1267,
	"./statuses/Hungry.svg": 1964,
	"./statuses/Immobilized.svg": 1392,
	"./statuses/Impaired.svg": 5270,
	"./statuses/Impaled.svg": 927,
	"./statuses/Joyful.svg": 9072,
	"./statuses/Major Wound.svg": 6627,
	"./statuses/Marked.svg": 8491,
	"./statuses/Minor Wound.svg": 7687,
	"./statuses/Moderate Wound.svg": 6313,
	"./statuses/Poised.svg": 7235,
	"./statuses/Poisoned.svg": 1208,
	"./statuses/Prone.svg": 4015,
	"./statuses/Pull.svg": 8186,
	"./statuses/Push.svg": 1351,
	"./statuses/Reeling.svg": 7413,
	"./statuses/Restrained.svg": 1132,
	"./statuses/Ridden.svg": 6493,
	"./statuses/Sealed.svg": 9419,
	"./statuses/Shatter.svg": 3882,
	"./statuses/Shocked.svg": 6520,
	"./statuses/Shred.svg": 3647,
	"./statuses/Shrouded.svg": 5171,
	"./statuses/Skipped.svg": 4373,
	"./statuses/Slide.svg": 1202,
	"./statuses/Slowed.svg": 9875,
	"./statuses/Soaked.svg": 310,
	"./statuses/Stress.svg": 479,
	"./statuses/Stunned.svg": 9364,
	"./statuses/Suffocating.svg": 4130,
	"./statuses/Suppressed.svg": 7253,
	"./statuses/Taunted.svg": 5262,
	"./statuses/Thirsty.svg": 4848,
	"./statuses/Tough.svg": 9516,
	"./statuses/Vulnerable.svg": 7135,
	"./terrain/BasicTerrain.svg": 2993,
	"./terrain/Carapace.svg": 7114,
	"./terrain/Earth.svg": 992,
	"./terrain/Electric.svg": 1817,
	"./terrain/Flame.svg": 4349,
	"./terrain/Ice.svg": 1401,
	"./terrain/Water.svg": 3137,
	"./terrain/Wind.svg": 6262,
	"./terrain/Wood.svg": 51,
	"./weapons/Axe.svg": 7248,
	"./weapons/Blade.svg": 5050,
	"./weapons/BladeRotate.svg": 4935,
	"./weapons/Blunt.svg": 5477,
	"./weapons/Bow.svg": 7408,
	"./weapons/Chain.svg": 1047,
	"./weapons/Improvised.svg": 2752,
	"./weapons/Lance.svg": 3617,
	"./weapons/Natural.svg": 1231,
	"./weapons/Rod.svg": 1955,
	"./weapons/Shield.svg": 4271,
	"./weapons/Sling.svg": 1079,
	"./weapons/Staff.svg": 1502,
	"./weapons/Throwing.svg": 1900,
	"./weapons/Unarmed.svg": 7890
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1980;